

const admin = "https://lmp.handsintechnology.in/api"
// const admin = "https://lmp.handsintechnology.in/api"

export default admin;